import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UtilityService } from "services/utility.service";

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styles: [
    "p{text-align: justify}",
    ".content-wrap{max-height:60vh;overflow-y:auto;margin-bottom:2rem}",
  ],
})
export class ConfirmationDialogComponent implements OnInit {
  item: string;
  file;
  error;
  remark = new FormControl(null, Validators.required);
  isValidFile: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private util: UtilityService,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {}
  ngOnInit() {
    this.item = this.data.item ? this.data.item : "";
    // console.log(this.data);
    this.data.body = this.data.body.replace("%%TMP%%", this.data.url);
  }
  confirm() {
    if (this.data.isBulkUpload) {
      this.error = null;
      if (this.file) {
        if (this.isValidFile == true) {
          return this.uploadFile();
        }
      }
      return (this.error = true);
    } else if (this.data.isReject) {
      if (this.remark.valid) {
        this.dialogRef.close({ remark: this.remark.value });
      } else {
        this.remark.markAsTouched();
      }
    } else {
      this.dialogRef.close({ id: this.data.id });
    }
  }
  getHierarchy() {
    const { applicationName, moduleName, subModuleName } = this.data;
    const level = [applicationName, moduleName, subModuleName];
    return level?.length ? level.filter((i) => i) : [];
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      // console.log(this.file);
      var validExts = new Array(".xlsx", ".xls", ".csv");
      var fileExt = this.file.name;
      fileExt = fileExt.substring(fileExt.lastIndexOf("."));
      console.log(fileExt);
      if (validExts.indexOf(fileExt) < 0) {
        this.util.showError(
          "Invalid file selected, valid files are of " +
            validExts.toString() +
            " types."
        );
        return this.isValidFile;
      } else {
        this.isValidFile = true;
        return this.isValidFile;
      }
    } else {
      this.file = null;
    }
  }

  uploadFile() {
    if (this.file) {
      this.dialogRef.close(this.file);
    }
  }
}
